import { getUxAttribution } from '../utils/uxTracker.js';
import { attributionReferrer } from './acquisitionAttribution.js';

function hasExternalReferrer(referrer) {
  try {
    const host = new URL(attributionReferrer(referrer)).hostname;
    return !/(^|\.)dathent\.(ai|com)$/.test(host)
      && !['localhost', '127.0.0.1'].includes(host)
      && !/(^|\.)(app-lending(?:-staging|-dev)?|dathent-ai(?:-staging|-dev)?)\.pages\.dev$/.test(host);
  } catch { return false; }
}

export function deriveFunnelSource({ landingPath = null, utmSource = null, referrer = null } = {}) {
  const path = String(landingPath || '').toLowerCase();
  const utm = String(utmSource || '').toLowerCase();
  if (path.includes('oauth-mcp') || utm === 'chatgpt') return 'chatgpt';
  if (path.startsWith('/shopify')) return 'shopify';
  return utm || hasExternalReferrer(referrer) ? 'web' : 'unknown';
}

export function getFunnelSource() {
  try {
    return deriveFunnelSource(getUxAttribution());
  } catch {
    return 'unknown';
  }
}
